"use client";

import { c as _c } from "react/compiler-runtime";
import Logo from "@public/assets/logos/logo-name.svg";
import Link from "next/link";
import { AccountDropdown } from "@/components/navbar/account-dropdown";
import type { MenuLinkProps } from "@/types/global";
import { MenuLink } from "../components";
import { MobileMenu } from "./MobileMenu";
import { useNavbarLinks } from "./useNavbarLinks";
export function NavbarClient() {
  const $ = _c(20);
  const {
    filteredPrimaryLinks,
    filteredSecondaryLinks,
    navLoggedIn
  } = useNavbarLinks();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/" aria-label="Go to homepage" className="block shrink-0 text-primary dark:text-white"><Logo role="presentation" /></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== filteredPrimaryLinks || $[2] !== filteredSecondaryLinks || $[3] !== navLoggedIn) {
    t1 = <div className="lg:hidden"><MobileMenu filteredPrimaryLinks={filteredPrimaryLinks} filteredSecondaryLinks={filteredSecondaryLinks} navLoggedIn={navLoggedIn} /></div>;
    $[1] = filteredPrimaryLinks;
    $[2] = filteredSecondaryLinks;
    $[3] = navLoggedIn;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== filteredPrimaryLinks) {
    t2 = filteredPrimaryLinks.length > 0 && <NavbarMenu links={filteredPrimaryLinks} />;
    $[5] = filteredPrimaryLinks;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== filteredSecondaryLinks) {
    t3 = filteredSecondaryLinks.length > 0 && <NavbarMenu links={filteredSecondaryLinks} />;
    $[7] = filteredSecondaryLinks;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== navLoggedIn) {
    t4 = navLoggedIn && <div className="flex items-center"><AccountDropdown /></div>;
    $[9] = navLoggedIn;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex items-center gap-6">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t5) {
    t6 = <div className="relative top-1.25 flex grow items-center justify-between gap-6 text-md text-secondary max-lg:hidden">{t2}{t5}</div>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <nav className="relative flex h-19 w-full items-center justify-between gap-6 px-4 py-5 md:px-8">{t0}{t1}{t6}</nav>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function NavbarMenu(t0) {
  const $ = _c(4);
  const {
    links
  } = t0;
  if (!links?.length) {
    return null;
  }
  let t1;
  if ($[0] !== links) {
    t1 = links.map(_temp);
    $[0] = links;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="flex items-center gap-6">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(link) {
  return <li key={link.label}><MenuLink {...link} activeUnderline={true} /></li>;
}